import {
  jb_simple_page_hero_css_default
} from "./chunk.62QBGHYY.js";
import {
  Spaceable
} from "./chunk.3FKBYJ4V.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-simple-page-hero/jb-simple-page-hero.ts
var JbSimplePageHero = class extends Spaceable(r) {
  _getContentSpacingProperties() {
    return { type: "no-vertical-space" };
  }
  render() {
    return ke`<h1><slot></slot></h1>`;
  }
};
JbSimplePageHero.styles = [reset_css_default, jb_simple_page_hero_css_default];
JbSimplePageHero = __decorateClass([
  customElement("jb-simple-page-hero")
], JbSimplePageHero);

export {
  JbSimplePageHero
};
